import { SVGProps } from 'react';
export const BagBilby = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 242 225"
		width={242}
		height={225}
		fill="none"
		{...props}
	>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M241.975 8.682 105.797.002 92.248 212.538l136.178 8.68z" />
			</clipPath>
			<clipPath id="b">
				<rect
					width={22.248}
					height={22.245}
					fill="#fff"
					rx={4}
					transform="rotate(14.998 -651.664 269.453) skewX(-.004)"
				/>
			</clipPath>
		</defs>
		<path
			fill="#C7E8E9"
			d="M206.917 176.553c0 54.145-42.677 42.788-96.829 42.788-54.152 0-101.764-34.339-101.764-88.483 0-54.145 47.612-75.605 101.764-75.605 54.152 0 96.829 67.156 96.829 121.3Z"
		/>
		<ellipse
			cx={96.801}
			cy={7.477}
			fill="#AFDDDE"
			rx={96.801}
			ry={7.477}
			transform="rotate(2.99 -3858.273 334.134) skewX(-.001)"
		/>
		<g
			clipPath="url(#a)"
			style={{
				display: 'inline',
			}}
		>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#868e93"
					d="m192.622 186.633-.118.114s3.568 1.647 5.974 2.015c1.119.171 2.247.28 3.378.325 1.257 1.941 1.73 4.274 1.894 6.07-2.107.184-4.23.113-6.32-.212-2.541-.388-6.54-1.161-7.756-1.401l1.015-3.166 1.705-3.948s.068.068.228.203z"
				/>
				<path
					fill="#a8b1ba"
					d="M224.078 171.966a32.518 32.518 0 0 1-1.778 9.876c-3.442 9.831-16.225 17.685-28.182 13.491-2.541-.893-6.316-2.829-6.316-2.829l4.851-6.788s2.81 2.047 4.827 2.755c7.265 2.549 19.54 0 23.022-9.944a25.783 25.783 0 0 0 1.34-6.483z"
				/>
				<path
					fill="#868e93"
					d="M201.348 196.464c.091-.433.668-3.594-1.473-6.251-.252-.32-.536-.663-.818-1.008-.149-.038-.298-.073-.444-.114-4.281-1.159-5.706-3.367-5.706-3.367l-4.377 6.992s3.606 2.289 9.821 3.443c.988.19 1.991.292 2.997.305z"
				/>
				<path
					fill="#fff"
					d="M218.972 170.65c-2.458-1.031-4.969-4.081-6.394-7.768a18.025 18.025 0 0 1 .098-13.523c1.68-4.021 5.011-6.806 7.512-8.419l1.712-1.099-.41 2.001c-.534 2.596-.816 6.463.874 10.133a.313.313 0 0 0 .171.166.33.33 0 0 0 .39-.108c.209-.282.932-1.24 1.856-2.352l1.524-1.847-.018 2.387a8.68 8.68 0 0 0 .773 3.826c.36.756.821 1.512 1.259 2.243 1.605 2.639 3.274 5.369 1.569 9.42-2.196 5.301-5.978 7.01-10.916 4.94z"
				/>
				<path
					fill="#1a2c48"
					d="m221.9 139.841-1.713 1.111c-2.5 1.621-5.832 4.399-7.512 8.419a18.03 18.03 0 0 0-.098 13.523c1.426 3.665 3.936 6.725 6.394 7.756 4.938 2.07 8.721.361 10.937-4.94 1.695-4.051.035-6.781-1.569-9.42-.446-.733-.906-1.489-1.259-2.243a8.67 8.67 0 0 1-.781-3.826l.005-2.388-1.523 1.838a60.307 60.307 0 0 0-1.856 2.352.333.333 0 0 1-.391.108.323.323 0 0 1-.171-.166c-1.69-3.67-1.407-7.537-.874-10.133zm.466-1.115a1.224 1.224 0 0 1 .653.66c.089.221.112.463.064.697l-.41 2.001c-.428 2.087-.685 5.041.252 7.98.277-.35.594-.743.939-1.157l1.529-1.835a1.207 1.207 0 0 1 1.342-.36l.05.02a1.201 1.201 0 0 1 .741 1.122l-.018 2.389a7.48 7.48 0 0 0 .665 3.295 24.24 24.24 0 0 0 1.206 2.137c1.68 2.773 3.586 5.893 1.652 10.514-1.224 2.929-2.929 4.902-5.064 5.868-2.136.965-4.674.885-7.452-.28-2.777-1.164-5.492-4.406-7.051-8.447a19.233 19.233 0 0 1 .111-14.425c1.8-4.305 5.326-7.252 7.968-8.966l1.712-1.112c.165-.107.353-.173.549-.191.196-.017.393.014.574.09z"
				/>
				<path
					fill="#e3e0ff"
					d="M220.664 166.973c2.785.343-.262-.111-.403-4.195-.046-1.26 1.166-3.528 1.47-2.772.305.756.741 3.4 2.755 3.007 1.846-.361 4.085-2.896 4.475-5.682l.043.073c1.337 2.312 2.362 4.82.904 8.319-2.216 5.293-5.998 7.009-10.937 4.94-2.458-1.031-4.968-4.081-6.394-7.769a19.019 19.019 0 0 1-.46-1.351c2.034 2.748 6.786 5.221 8.547 5.43z"
				/>
				<path
					fill="#1a2c48"
					d="M200.903 197.059c9.907 0 19.078-6.848 21.944-15.03a32.87 32.87 0 0 0 1.811-10.083l-.058-.343-3.294.02-.038.381a25.517 25.517 0 0 1-1.309 6.332c-1.511 4.31-4.969 7.612-9.741 9.301-4.102 1.452-8.907 1.563-12.544.287-1.911-.67-4.651-2.656-4.679-2.677l-.471-.345-5.58 7.814.594.31c.156.081 3.838 1.966 6.389 2.861a20.97 20.97 0 0 0 6.976 1.172zm22.581-24.493a32.879 32.879 0 0 1-1.73 9.074c-2.72 7.761-11.423 14.26-20.824 14.26a19.945 19.945 0 0 1-6.62-1.109 58.989 58.989 0 0 1-5.644-2.496l4.123-5.77c.904.625 2.911 1.941 4.5 2.498 3.931 1.379 8.907 1.261 13.314-.287 5.107-1.807 8.814-5.364 10.446-10.012a26.56 26.56 0 0 0 1.327-6.115z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<path
				fill="#a8b1ba"
				d="M149.425 131.788s-28.33 4.395-20.512 32.449z"
				style={{
					display: 'inline',
				}}
			/>
			<path
				fill="#1a2c48"
				d="M149.952 132.494c-8.709.786-17.119 6.599-19.868 14.986-1.602 4.896-1.418 10.164-.52 15.179.156.879-1.208 1.163-1.364.284-1.448-8.099-.848-16.918 4.785-23.366 3.448-3.958 8.275-6.516 13.332-7.811 1.098-.298 3.13-.51 4.263-.632.556.314.26 1.28-.628 1.36z"
				style={{
					display: 'inline',
				}}
			/>
			<path
				fill="#a8b1ba"
				d="M199.465 107.271c-.266 2.208-.5 4.422-.744 6.617-.957 8.631-1.559 17.196-.851 25.882.596 7.328 1.264 14.4.712 21.777-1.417 19.033-10.224 37.32-12.776 56.247l-42.288-2.797a36.479 36.479 0 0 1 15.98-6.446c5.781-.851 11.346.593 17.078.741-.222-.472-.456-.95-.702-1.424-4.072-7.874-13.192-16.4-22.48-16.969-3.571-.2-7.084.958-9.83 3.242-3.565 2.992-4.697 6.99-5.058 11.424-.077.745-1.153 8.52-1.153 8.52s-28.329-1.394-41.597-2.378c9.539-6.509 22.042-8.479 33.137-5.216-4.274-14.76-3.098-30.074.275-45.066 2.939-13.048 20.014-29.568 30.891-37.611-19.111-3.644-35.2-17.163-48.675-30.412-2.072-2.036-3.71-3.644-4.843-4.333-4.893-2.972-5.852-6.832-4.635-9.342 1.134-2.333 4.347-3.921 8.966-2.21 3.298 1.221 5.91 4.094 8.435 6.872 2.525 2.777 5.078 5.582 8.251 6.761 9.398 3.497 15.529-2.015 22.002-7.835 3.698-3.326 7.927-6.944 12.429-8.602 0 0-.189-1.588-3.652-4.159-2.289-1.693-.173-4.667 4.752-3.212 4.926 1.456 8.786 5.118 8.786 5.118s.779-1.732-.697-4.605c-.905-1.761-2.434-4.293.707-2.757 3.142 1.536 7.264 5.934 7.264 5.934-.776-4.738-2.998-10.121-5.326-15.766-3.06-7.422-6.337-13.365-6.333-20.168.003-5.018 1.344-11.467 3.99-19.16 1.962-5.698 3.891-9.893 3.971-10.056a1.194 1.194 0 0 1 1.441-.644c.184.056.351.157.488.292.572.555 14.103 12.049 17.081 29.916 1.364 8.18-.356 17.253-1.874 25.255-.788 4.157-1.493 7.876-1.66 10.905 0 0 .781.365 2.097-.582 1.395-1.01.917-4.41 2.301-3.557 1.186.73 1.835 7.958 1.835 7.958 1.42-3.535 1.986-7.445 2.577-11.522.855-5.897 1.74-11.992 5.21-17.922 8.655-14.701 23.429-21.977 24.058-22.366a1.194 1.194 0 0 1 1.599.345c.266.388 6.587 7.98-1.058 26.164-4.109 9.77-10.187 16.82-15.552 23.042-4.568 5.298-8.513 9.888-10.448 15.07-2.279 6.131-3.309 12.57-4.081 19.035z"
				style={{
					display: 'inline',
				}}
			/>
			<path
				fill="#868e93"
				d="M205.387 84.383s-2.028 5.156-3.006 7.372c-1.101 2.49-1.183 5.247-1.819 7.887-1.393 5.755-1.965 11.673-2.318 17.573-.537 8.969-1.055 18.188-.395 27.16.385 4.913.467 9.844.247 14.767-1.604 30.768-10.564 38.545-12.255 58.787l-4.083-.26c1.868-19.15 10.61-28.381 13.228-59.557 1.613-19.189-1.932-38.556 2.765-57.592 2.911-11.793 7.636-16.136 7.636-16.136z"
				style={{
					display: 'inline',
				}}
			/>
			<path
				fill="#feaf86"
				d="M185.445 67.715a.61.61 0 0 0 .241-.587c-.471-3.093.156-7.559.887-12.728 1.069-7.66 2.305-16.337.365-23.681-2.096-7.923-9.038-17.753-9.343-18.167a.61.61 0 0 0-.585-.254.618.618 0 0 0-.497.4c-.179.49-4.352 12.118-2.682 22.795 1.914 12.228 10.256 27.688 10.339 27.84.039.07.126 2.857.295 3.98a.629.629 0 0 0 .246.403.624.624 0 0 0 .734-.001z"
			/>
			<path
				fill="#f38c4f"
				d="M185.686 67.128c-.471-3.093.159-7.559.887-12.728 1.069-7.66 2.305-16.337.365-23.681-2.096-7.923-9.038-17.753-9.343-18.167a.61.61 0 0 0-.585-.254.618.618 0 0 0-.497.4 34.27 34.27 0 0 0-.61 1.868.578.578 0 0 1 .251.207c.297.413 7.248 10.247 9.34 18.166 1.944 7.344.722 16.023-.362 23.682-.38 2.685-.73 5.169-.915 7.388.049.913.13 2.515.248 3.304a.629.629 0 0 0 .246.403.624.624 0 0 0 .734-.001.61.61 0 0 0 .241-.587z"
			/>
			<path
				fill="#feaf86"
				d="m201.719 77.019.067.042a.644.644 0 0 0 .86-.273c1.414-2.72 4.493-5.894 8.06-9.567 5.288-5.458 11.286-11.621 13.997-18.562 2.924-7.486 3.101-19.28 3.106-19.777a.625.625 0 0 0-.333-.571.637.637 0 0 0-.661.035c-.425.286-10.468 7.098-15.332 16.527-5.558 10.795-7.877 27.847-7.914 28.016-.005.075-1.552 2.324-2.065 3.31a.638.638 0 0 0 .215.82z"
			/>
			<path
				fill="#f38c4f"
				d="M227.809 28.882a.625.625 0 0 0-.333-.571.637.637 0 0 0-.661.035c-.094.063-.677.458-1.575 1.137a.633.633 0 0 1 .082.312c-.006.498-.185 12.294-3.097 19.778-2.712 6.941-8.705 13.116-13.994 18.563-1.866 1.91-3.586 3.695-5.014 5.345-.492.754-1.338 2.038-1.693 2.72a.638.638 0 0 0 .207.819l.067.042a.642.642 0 0 0 .86-.273c1.414-2.72 4.493-5.894 8.06-9.567 5.287-5.458 11.285-11.621 13.997-18.562 2.912-7.487 3.089-19.28 3.094-19.778z"
				style={{
					display: 'inline',
				}}
			/>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#fff"
					d="m122.18 205.104 8.765 8.671-33.855-2.201s3.71-7.517 25.09-6.47zM170.22 208.722l9.698 8.769-34.622-2.701s3.556-7.114 24.924-6.068z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M118.902 205.694c-3.376.869-6.468 3.52-6.97 7.064-.126.878-1.504.796-1.389-.089.595-4.189 4.059-7.301 8.085-8.331.87-.234 1.148 1.137.283 1.357z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M113.76 205.865c-3.54.56-6.318 3.384-7.306 6.717-.255.853-1.571.401-1.316-.454 1.129-3.771 4.339-6.988 8.331-7.623.881-.141 1.172 1.219.285 1.36zM166.02 209.074c-3.845.137-7.349 3.194-8.486 7.045-.255.853-1.572.404-1.317-.455 1.304-4.405 4.86-7.546 9.565-7.715.897-.033 1.126 1.092.238 1.125z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M159.64 209.232c-3.505.299-6.087 3.597-7.367 6.537-.342.816-1.674.369-1.313-.451 1.454-3.344 4.35-6.78 8.33-7.12.877-.077 1.239.958.35 1.034z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<path
				fill="#fff"
				d="M160.074 123.814c-.389.393-7.621-2.108-8.492-2.448-2.835-1.107-5.646-2.173-8.371-3.503-3.709-1.807-7.448-4.737-10.95-6.91-1.696-1.053-3.304-2.323-5.037-3.303-1.262-.715-2.94-1.143-3.587-2.61a.587.587 0 0 1-.016-.445.61.61 0 0 1 .312-.334.59.59 0 0 1 .457-.016c10.639 3.943 22.694 1.811 32.639 1.06 6.233-.472 12.119-.914 17.125-.132 17.064 2.667 13.663 26.019 11.838 38.33-1.299 8.758-2.157 30.913-17.792 38.525-5.665 2.76-10.263 3.658-18.996 2.075-7.129-1.289-12.312-7.008-13.932-13.903-2.11-8.981 2.991-17.975 7.529-25.399 4.581-7.499 12.179-15.792 17.273-20.987z"
			/>
			<g fill="#1a2c48">
				<path d="M182.881 183.955c.163.013.327.003.487-.027.941-.172 1.871-1.04 2.93-2.752a12.52 12.52 0 0 1 1.329-1.842l-.007.122c-.251 2.064-.324 3.166.838 3.718a1.553 1.553 0 0 0 1.528-.088c2.066-1.276 2.807-7.566 2.843-9.23a.646.646 0 0 0-.634-.653.648.648 0 0 0-.655.632c-.043 2.643-1.085 7.447-2.234 8.159a.26.26 0 0 1-.292.019c-.243-.114-.368-.284-.111-2.403.051-.435.191-1.582-.631-1.869-.568-.204-1.345-.007-3.061 2.758-1.088 1.753-1.764 2.11-2.067 2.166a.71.71 0 0 1-.595-.192c-.355-.269-.116-2.642.203-4.459a.637.637 0 0 0-.29-.653.648.648 0 0 0-.89.197.652.652 0 0 0-.09.233c-.178 1.012-.933 4.781.287 5.705.318.257.705.417 1.112.459zM183.534 192.634c.157.012.315.01.471-.008 3.053-.341 4.989-5.332 5.194-5.901a.641.641 0 0 0-.382-.826.644.644 0 0 0-.827.381c-.495 1.336-2.207 4.852-4.127 5.068-.132.015-.356.024-.425-.076-.335-.485.279-2.46 1.041-3.93a.645.645 0 0 0-1.148-.591c-.461.889-1.89 3.898-.954 5.25a1.47 1.47 0 0 0 1.157.633z" />
			</g>
			<path
				fill="#1a2c48"
				d="M200.16 107.315c-.88 7.422-1.736 14.875-1.882 22.356-.145 7.481.856 14.925 1.132 22.41a88.206 88.206 0 0 1-1.756 20.84c-1.434 7.083-3.509 14.015-5.52 20.948-2.293 7.892-4.516 15.825-5.634 23.98a.708.708 0 0 1-.739.649l-42.287-2.797c-.559-.036-.928-.85-.417-1.215a37.62 37.62 0 0 1 14.868-6.371c6.267-1.186 12.421.276 18.696.484l-.666 1.004c-3.831-8.001-11.222-15.809-20.22-17.695-4.805-1.004-10.02.434-13.23 4.254-2.543 3.025-2.947 6.717-3.428 10.473-.319 2.501-.67 4.997-1.015 7.495a.71.71 0 0 1-.739.649 3004.028 3004.028 0 0 1-31.055-1.69c-3.513-.224-7.027-.433-10.541-.692-.75-.048-.811-.953-.268-1.315a40.61 40.61 0 0 1 16.256-6.32 40.696 40.696 0 0 1 17.418 1.074l-.909.812c-4.037-14.166-3.161-29.038-.162-43.317 2.323-11.043 9.834-20.027 17.619-27.876a122.978 122.978 0 0 1 13.931-12.151l.417 1.214c-10.605-2.066-20.295-7.03-29.02-13.286a143.005 143.005 0 0 1-12.388-10.061 219.636 219.636 0 0 1-6.033-5.641c-1.836-1.777-3.589-3.726-5.603-5.306-1.725-1.35-3.536-2.338-4.813-4.187-.928-1.34-1.532-2.951-1.409-4.598.251-3.389 3.364-5.366 6.57-5.336 5.256.045 9.065 4.055 12.347 7.643 1.901 2.082 3.795 4.28 6.203 5.787a14.287 14.287 0 0 0 7.825 2.003c5.304-.155 9.657-3.661 13.471-7.014 4.463-3.92 8.86-8.264 14.515-10.428l-.368.762c-.287-1.968-2.95-2.987-4.036-4.363-1.193-1.525-.228-3.271 1.393-3.901 2.812-1.09 6.209.468 8.652 1.797a24.549 24.549 0 0 1 5.081 3.613l-1.177.232c.775-1.857-.655-3.907-1.406-5.523-.475-1.024-.958-2.84.796-2.774 2.006.076 4.22 2.173 5.633 3.39a44.553 44.553 0 0 1 3.413 3.251l-1.2.599c-1.062-6.13-3.708-11.989-6.138-17.675-2.248-5.25-4.908-10.567-5.429-16.335-.426-4.721.524-9.549 1.7-14.09a109.105 109.105 0 0 1 5.464-15.794c.426-.987.783-2.352 1.935-2.693.913-.272 1.596.215 2.231.797a54.14 54.14 0 0 1 4.478 4.632c5.555 6.439 9.853 14.093 11.831 22.393 1.521 6.414 1.222 12.963.278 19.431-.961 6.603-2.795 13.128-3.214 19.789l-.47-.7c.891.347 1.793-.778 2.044-1.472.25-.694.296-1.59.723-2.228.686-1.006 1.853-.586 2.379.337 1.231 2.156 1.317 5.273 1.543 7.695l-1.354-.086c2.546-6.534 2.484-13.718 4.21-20.466 1.659-6.472 5.131-12.115 9.517-17.112 5.034-5.759 11.336-10.955 18.203-14.426 4.391-2.244 5.525 7.85 5.591 10.106.167 5.673-1.435 11.349-3.572 16.553-2.5 6.082-6.007 11.65-10.079 16.81-4.508 5.724-9.881 10.884-13.761 17.087-4.344 6.938-5.473 15.62-6.443 23.59-.109.882-1.504.799-1.389-.089.814-6.746 1.811-13.735 4.451-20.048 2.441-5.837 6.934-10.598 11.008-15.334 8.123-9.426 15.692-19.894 17.898-32.398.664-3.762.807-7.737-.306-11.424-.278-.925-1.104-4.017-2.482-3.778-.482.083-1.098.594-1.506.832a65.955 65.955 0 0 0-14.143 10.825c-4.969 5.017-9.238 10.952-11.248 17.778-2.115 7.193-1.877 14.947-4.614 21.968-.226.58-1.273.643-1.34-.086-.211-2.331-.395-4.922-1.29-7.103-.327-.794-.232-.099-.383.448-.197.72-.366 1.495-.818 2.11-.655.885-2.167 1.678-3.275 1.24a.711.711 0 0 1-.467-.7c.347-5.445 1.7-10.803 2.632-16.168.984-5.678 1.762-11.501 1.24-17.266-.81-8.854-4.775-17.301-10.11-24.32a58.191 58.191 0 0 0-5.395-6.162c-.448-.443-.932-1.056-1.471-1.395-.891-.561-1.157.138-1.49.902a113.57 113.57 0 0 0-5.067 13.93c-1.318 4.552-2.403 9.301-2.393 14.066.012 6.285 2.962 12.068 5.382 17.728 2.481 5.79 5.185 11.776 6.266 18.02a.699.699 0 0 1-.813.805.7.7 0 0 1-.387-.207 32.767 32.767 0 0 0-7.55-6.001 2.753 2.753 0 0 0-.541-.17c.169-.199.254-.17.25.085.139.368.299.729.48 1.08.472.844.871 1.726 1.195 2.637.332 1.082.542 2.474.089 3.56a.697.697 0 0 1-.523.445.704.704 0 0 1-.654-.212 22.927 22.927 0 0 0-3.71-2.74c-2.215-1.355-5.559-3.182-8.249-2.371-3.004.906.417 2.947 1.427 3.956.716.715 1.694 1.742 1.855 2.81a.703.703 0 0 1-.368.762c-9.039 3.46-14.233 12.598-23.048 16.325a15.84 15.84 0 0 1-11.922.147c-4.684-1.788-7.655-6.228-11.066-9.645-2.914-2.92-8.996-7.06-12.889-3.284-3.352 3.249.487 7.626 3.335 9.485 1.649 1.076 3.038 2.477 4.439 3.847 1.859 1.819 3.719 3.636 5.62 5.411 3.79 3.542 7.692 6.952 11.823 10.113 9.333 7.163 19.846 13.118 31.51 15.395.519.102.956.811.413 1.214-8.783 6.519-16.981 14.33-23.462 23.148-3.012 4.076-5.818 8.574-7.101 13.528a104.423 104.423 0 0 0-3.058 21.204c-.359 8.139.416 16.279 2.652 24.126.155.54-.437.934-.908.811a39.378 39.378 0 0 0-16.864-.996 39.296 39.296 0 0 0-15.719 6.163l-.27-1.312c12.623.932 25.273 1.553 37.924 2.194l3.655.184-.739.648c.345-2.499.696-4.994 1.016-7.495.51-4.004.981-7.926 3.663-11.16a14.74 14.74 0 0 1 5.639-4.089 14.78 14.78 0 0 1 6.892-1.049c4.769.405 9.243 2.742 12.931 5.683a37.317 37.317 0 0 1 10.396 13.05.7.7 0 0 1-.318.928.698.698 0 0 1-.351.075c-5.967-.198-11.883-1.644-17.846-.598a36.022 36.022 0 0 0-14.71 6.144l-.414-1.215 42.288 2.797-.739.648c1.953-14.224 7.189-27.677 10.425-41.61 1.634-7.03 2.628-14.15 2.552-21.378-.079-7.478-1.18-14.899-1.22-22.389-.044-8.423.912-16.817 1.895-25.169.116-.871 1.506-.788 1.403.101z"
				style={{
					display: 'inline',
				}}
			/>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#1a2c48"
					d="M176.229 109.365a1.612 1.612 0 0 1 2.127 2.141c-2.279 4.943-6.837 11.531-14.178 8.171a13.997 13.997 0 0 1-6.992-6.82 1.603 1.603 0 0 1 1.751-2.253c3.918.705 11.4 1.486 17.292-1.239z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#f38c4f"
					d="M167.796 115.66c3.339.045 4.179 2.005 4.179 2.005s-2.733 3.074-8.737.312c0 0 .389-2.374 4.558-2.317z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#a8b1ba"
					d="M195.142 139.074c1.912 1.414 3.599 3.173 5.193 4.92 2.392 2.625 4.785 5.382 6.202 8.674 3.038 7.052-.161 13.556-5.327 18.567-2.409 2.335-4.635 5.033-7.415 6.931a14.58 14.58 0 0 1-4.4 2.115c-3.875 1.02-6.664-1.033-7.708-3.522-1.075-2.56-.263-5.304 1.714-7.105 2.2-2.01 4.497-3.915 6.673-5.95 1.316-1.231 2.519-2.325 3.105-4.049 1.298-3.809-1.16-7.365-4.242-9.43"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#868e93"
					d="M184.789 180.286c.782.899 3.577.263 4.594.003a14.59 14.59 0 0 0 4.4-2.115c2.791-1.897 5.018-4.606 7.415-6.931 5.164-5.02 8.374-11.523 5.339-18.575-1.417-3.292-3.81-6.038-6.202-8.674-1.594-1.747-3.086-3.65-4.127-5.052-1.041-1.402-1.737-.546-1.737-.546-1.791 1.115 3.404 5.859 5.025 7.767 1.622 1.909 3.119 3.998 4.119 6.319 1.855 4.305 1.36 8.965-.922 13a22.872 22.872 0 0 1-4.559 5.606c-2.03 1.856-3.774 3.964-5.977 5.649a20.678 20.678 0 0 1-3.435 2.16 16.32 16.32 0 0 1-1.934.804c-.612.207-1.476.262-1.999.585z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M193.575 174.68a.653.653 0 0 0-.098-.838.622.622 0 0 0-.827-.02l-6.921 5.684a.641.641 0 0 0-.275.442.659.659 0 0 0 .138.505.635.635 0 0 0 .46.234.63.63 0 0 0 .477-.193l6.922-5.685a.599.599 0 0 0 .124-.13z"
					style={{
						strokeWidth: 1.06431,
					}}
				/>
				<path
					fill="#1a2c48"
					d="M190.485 171.732a.635.635 0 0 0 .074-.833.66.66 0 0 0-.833-.176l-8.204 4.12a.626.626 0 0 0-.337.68c.017.09.053.175.105.25a.672.672 0 0 0 .851.18l8.193-4.114a.564.564 0 0 0 .151-.107z"
					style={{
						display: 'inline',
						strokeWidth: 1.06167,
					}}
				/>
				<path
					fill="#1a2c48"
					d="M195.531 138.499c2.846 2.157 5.301 4.858 7.579 7.596 2.053 2.475 3.913 5.21 4.785 8.34 1.794 6.405-1.442 12.51-5.876 16.976-4.006 4.036-9.416 10.958-15.961 9.704-5.62-1.08-7.168-7.97-3.288-11.823 1.567-1.558 3.323-2.944 4.971-4.412 1.436-1.276 3.159-2.598 4.188-4.245 2.319-3.7-.27-7.663-3.392-9.83-.735-.507.039-1.661.776-1.15 4.024 2.789 6.749 8.077 3.275 12.439-1.93 2.421-4.559 4.372-6.873 6.409-1.204 1.062-2.553 2.066-3.265 3.542a5.377 5.377 0 0 0 .055 4.868c1.495 2.86 4.72 3.448 7.575 2.421 3.161-1.14 5.645-3.494 7.946-5.868 4.303-4.408 9.183-9 8.981-15.68-.111-3.774-2.04-7.142-4.332-10.026-2.329-2.93-4.941-5.852-7.929-8.117-.712-.541.062-1.697.777-1.153z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#fff"
					d="M185.774 97.198c-.216 3.663-3.245 6.458-6.765 6.254-3.52-.204-6.206-3.343-5.972-7.005.233-3.662 3.244-6.457 6.765-6.253 3.52.204 6.205 3.345 5.972 7.004z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#e2deef"
					d="M181.155 90.61a6.743 6.743 0 0 1 2.052 5.286c-.216 3.66-3.245 6.457-6.765 6.253a6.176 6.176 0 0 1-1.982-.453 6.218 6.218 0 0 0 3.944 1.72c3.52.21 6.557-2.59 6.762-6.254a6.616 6.616 0 0 0-.957-3.913 6.642 6.642 0 0 0-3.054-2.639z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M186 99.12c-1.25 3.791-5.35 5.804-8.983 4.538-3.633-1.266-5.522-5.362-4.204-9.129 1.319-3.767 5.351-5.804 8.983-4.538a8.357 8.357 0 0 1 3.778 2.906c1.507 2.026.967 4.576.426 6.222zm-9.674 2.894a5.069 5.069 0 0 1-.593-4.65c.895-2.551 3.471-3.998 5.751-3.206 2.28.791 3.402 3.517 2.518 6.083-.032.099-.076.195-.114.282a6.305 6.305 0 0 0 .987-1.806c1.101-3.146-.454-6.557-3.467-7.607-3.013-1.05-6.356.659-7.457 3.805-.965 2.749.093 5.694 2.375 7.099zm3.303-3.327a.364.364 0 0 0 .551-.09.36.36 0 0 0 .049-.202l-.181-2.816a.36.36 0 0 0-.152-.26.366.366 0 0 0-.295-.059 4.232 4.232 0 0 0-1.977 1.103.372.372 0 0 0-.085.121.36.36 0 0 0 .089.41z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M186 99.12c.08-.207 2.242-6.406-.629-11.136a8.413 8.413 0 0 0-5.171-3.806.737.737 0 0 0-.777.59.732.732 0 0 0 .494.84 7.074 7.074 0 0 1 4.191 3.133 9.918 9.918 0 0 1 1.297 6.266c-.159 1.358.45 4.477.595 4.112z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#fff"
					d="M169.013 91.7c-.216 3.66-3.244 6.457-6.765 6.253-3.52-.204-6.196-3.344-5.98-7.005.215-3.66 3.244-6.457 6.764-6.253 3.521.204 6.183 3.34 5.981 7.005z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#e2deef"
					d="M164.389 85.112a6.733 6.733 0 0 1 2.06 5.283c-.216 3.66-3.245 6.457-6.765 6.253a6.14 6.14 0 0 1-1.979-.453 6.221 6.221 0 0 0 3.929 1.722c3.52.207 6.558-2.593 6.762-6.254a6.607 6.607 0 0 0-.954-3.913 6.643 6.643 0 0 0-3.053-2.638z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M169.233 93.62c-1.249 3.789-5.35 5.802-8.982 4.536-3.633-1.266-5.522-5.362-4.204-9.128 1.318-3.767 5.338-5.8 8.983-4.54a8.368 8.368 0 0 1 3.778 2.907c1.481 2.024.966 4.576.425 6.225zm-9.674 2.893a5.066 5.066 0 0 1-.593-4.648c.895-2.55 3.472-4 5.752-3.206 2.279.794 3.402 3.514 2.518 6.08-.033.102-.077.195-.114.282a6.382 6.382 0 0 0 .987-1.808c1.101-3.144-.454-6.558-3.467-7.607-3.013-1.05-6.357.67-7.464 3.815-.96 2.75.1 5.686 2.381 7.092zm3.305-3.34a.358.358 0 0 0 .551-.085.354.354 0 0 0 .048-.203l-.181-2.817a.349.349 0 0 0-.046-.147.37.37 0 0 0-.246-.175.365.365 0 0 0-.155.004 4.2 4.2 0 0 0-1.976 1.1.362.362 0 0 0-.083.41c.02.046.05.087.087.12z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M169.234 93.62c.08-.209 2.242-6.408-.63-11.137a8.41 8.41 0 0 0-5.17-3.807.741.741 0 0 0-.83.588.74.74 0 0 0 .546.857 7.049 7.049 0 0 1 4.191 3.13 9.918 9.918 0 0 1 1.297 6.266c-.15 1.347.45 4.465.596 4.103z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<g
				style={{
					display: 'inline',
				}}
			>
				<path
					fill="#feaf86"
					d="M112.321 78.525c5.579 3.415 6.786 8.368 3.32 11.729-3.37 3.277-8.47-.305-9.311-.883-5.383-3.748-5.141-8.151-3.526-10.421 1.484-2.082 5.077-3.148 9.517-.425z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#1a2c48"
					d="M110.702 77.68c-3.676-1.594-6.596-.548-7.892 1.267-1.615 2.273-1.858 6.673 3.526 10.421a15.036 15.036 0 0 0 2.619 1.485c1.98.857 4.651 1.386 6.692-.596 3.46-3.36 2.253-8.314-3.32-11.73a13.087 13.087 0 0 0-1.62-.847zm.493-1.128c.612.268 1.205.577 1.774.927 3.426 2.1 5.503 4.84 5.807 7.719.243 2.17-.563 4.278-2.267 5.94-2.01 1.955-4.792 2.247-8.038.844a15.96 15.96 0 0 1-2.805-1.59l-.02-.002c-3.536-2.462-4.644-5.085-4.953-6.852a7.05 7.05 0 0 1 1.127-5.283c1.544-2.202 5.048-3.572 9.369-1.703z"
					style={{
						display: 'inline',
					}}
				/>
				<path
					fill="#f38c4f"
					d="M102.516 79.412c.093.591.245 1.17.457 1.73.893 2.256 2.013 4.608 8.324 7.337 2.127.92 3.699 1.236 4.84 1.247a7.822 7.822 0 0 1-.49.528c-3.37 3.277-8.471-.305-9.311-.883-5.036-3.51-5.148-7.59-3.82-9.959z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
		</g>
		<g
			style={{
				display: 'inline',
			}}
		>
			<path
				fill="#fff"
				d="M87.497 127.094c-9.96-5.657-27.067-4.928-34.377-3.857-10.298.738-26.575.802-36.633 9.51-10.058 8.708-10.042 32.165-10.724 48.356-.682 16.191 27.789 28.844 53.572 31.736 25.782 2.893 44.096 1.543 52.754-18.293 8.658-19.837-.577-42.059-1.153-47.041-.576-4.983-10.99-13.339-23.439-20.411z"
			/>
			<path
				fill="#ff923d"
				d="M90.235 129.671c-9.96-5.657-27.068-4.928-34.377-3.857-10.299.738-26.576.802-36.634 9.51S9.182 167.489 8.5 183.68c-.682 16.191 27.79 28.844 53.572 31.736 25.783 2.893 44.096 1.543 52.754-18.293 8.659-19.837-.577-42.058-1.153-47.041-.576-4.983-10.989-13.339-23.438-20.411z"
			/>
			<path
				fill="#1a2c48"
				fillRule="evenodd"
				d="M69.27 123.393c-6.38-.387-12.433.059-16.04.588a.518.518 0 0 1-.056.006c-1.078.078-2.215.147-3.4.22-4.52.277-9.728.596-14.927 1.536-6.556 1.186-12.986 3.346-17.868 7.572-4.805 4.16-7.29 11.95-8.627 20.915-1.108 7.432-1.408 15.508-1.675 22.693-.053 1.444-.106 2.852-.163 4.212-.16 3.807 1.388 7.456 4.28 10.865 2.895 3.413 7.11 6.55 12.188 9.297 10.155 5.494 23.622 9.357 36.437 10.795 12.885 1.446 23.782 1.813 32.514-.601 8.669-2.396 15.23-7.54 19.467-17.246 4.249-9.736 4.12-20.089 2.831-28.678-.643-4.29-1.573-8.125-2.382-11.209a404.42 404.42 0 0 0-.56-2.103c-.189-.702-.363-1.349-.511-1.924-.29-1.117-.511-2.058-.589-2.74-.12-1.038-.776-2.36-1.999-3.919-1.21-1.541-2.914-3.237-5.008-5.016-4.185-3.557-9.859-7.388-16.056-10.908-4.83-2.744-11.46-3.966-17.857-4.355zm.09-1.501c6.475.393 13.38 1.635 18.509 4.548 6.252 3.552 12.01 7.435 16.287 11.07 2.138 1.817 3.923 3.586 5.217 5.234 1.28 1.63 2.142 3.221 2.31 4.674.065.564.259 1.408.551 2.537.15.581.32 1.211.504 1.9.176.652.365 1.357.566 2.122.814 3.104 1.76 6.999 2.415 11.367 1.309 8.726 1.468 19.402-2.941 29.502-4.421 10.13-11.347 15.58-20.444 18.094-9.034 2.498-20.185 2.094-33.083.647-12.968-1.455-26.628-5.365-36.984-10.967-5.178-2.802-9.564-6.045-12.62-9.648-3.06-3.607-4.816-7.612-4.635-11.9.056-1.345.108-2.742.161-4.179.267-7.185.57-15.362 1.692-22.885 1.34-8.989 3.877-17.282 9.13-21.83 5.176-4.481 11.913-6.707 18.584-7.915 5.296-.958 10.62-1.283 15.147-1.56a314.85 314.85 0 0 0 3.313-.214c3.704-.54 9.846-.99 16.322-.597z"
				clipRule="evenodd"
			/>
			<path
				fill="#fff"
				d="M23.864 107.471c6.793 14.987 27.037 19.805 36.31 20.341l15.45-2.806c28.496 5.013 45.017-5.543 49.715-11.447-1.756-1.206-8.25-4.028-20.174-5.668-11.923-1.641-28.81 7.234-35.764 11.877-15.264-15.03-36.718-14.461-45.537-12.297z"
			/>
			<path
				fill="#ff923d"
				d="M27.354 109.296c6.793 14.987 27.037 19.805 36.31 20.341l15.45-2.806c28.496 5.013 45.017-5.543 49.715-11.447-1.756-1.206-8.25-4.028-20.174-5.668-11.923-1.641-28.81 7.234-35.764 11.877-15.264-15.03-36.718-14.461-45.537-12.297z"
			/>
			<path
				fill="#1a2c48"
				fillRule="evenodd"
				d="M85.695 112.173c-6.526 2.572-12.439 5.925-15.876 8.22a.752.752 0 0 1-.945-.09c-14.51-14.286-34.755-14.251-43.927-12.308 3.404 6.8 9.739 11.394 16.448 14.378 6.93 3.084 14.17 4.408 18.734 4.683l15.36-2.79a.76.76 0 0 1 .265-.001c27.211 4.787 43.262-4.755 48.44-10.517-2.385-1.289-8.58-3.661-19.131-5.112-5.766-.794-12.82.956-19.368 3.537zm-.551-1.4c6.615-2.607 13.966-4.474 20.124-3.627 11.969 1.646 18.599 4.49 20.497 5.793a.751.751 0 0 1 .163 1.088c-4.892 6.147-21.664 16.738-50.302 11.742l-15.317 2.783a.814.814 0 0 1-.178.011c-4.714-.273-12.184-1.629-19.347-4.816-7.159-3.184-14.103-8.24-17.605-15.966a.752.752 0 0 1 .506-1.041c8.873-2.176 30.316-2.779 45.807 12.067 3.57-2.328 9.324-5.54 15.652-8.034z"
				clipRule="evenodd"
			/>
			<g fill="#1a2c48">
				<path d="M54.638 150.263c-1.266-.218-2.24-.95-2.815-2.115-1.254-2.543-.516-5.734 1.003-8.62a1.248 1.248 0 0 1 1.685-.523c.609.321.845 1.072.524 1.681-1.402 2.668-1.687 4.91-.973 6.363.218.446.53.679 1 .763.557.095.997.005 1.393-.292 1.078-.807 1.428-2.437 1.505-3.099a1.241 1.241 0 0 1 1.383-1.09 1.244 1.244 0 0 1 1.095 1.384c-.044.367-.368 3.223-2.487 4.804-.942.705-2.09.964-3.31.749zM90.74 149.727a1.23 1.23 0 0 0-1.074-1.337c-.068-.01-.135-.011-.2-.012l-.016-.004a1.243 1.243 0 0 0-1.295 1.194c-.011.338-.037.668-.074.992-.63 3.873-1.892 5.009-2.202 5.217-.411.277-.946.438-1.397.272-.53-.197-.866-.495-1.06-.951-.531-1.237-.019-2.823.245-3.435a1.241 1.241 0 0 0-.652-1.636 1.246 1.246 0 0 0-1.64.651c-.145.34-1.293 2.976-.25 5.404.465 1.082 1.33 1.879 2.494 2.304l.035.009c-1.951 1.547-4.306 2.194-8.105 1.809-.686-.067-1.307.341-1.395.979-.089.643.34 1.232 1.253 1.323 3.071.302 5.682.036 7.979-1.106 2.407-1.199 4.317-2.89 5.907-6.194.668-1.391 1.21-3.194 1.444-5.484z" />
				<path d="M68.754 154.299c-.045-.112-1.056-2.073-2.538-4.655.993-.051 1.885-.291 2.626-.692 1.003-.543 1.654-1.28 1.937-2.333.353-1.317.006-2.571-.974-3.529-.76-.74-1.908-1.319-3.419-1.723-3.069-.823-6.018-1.209-6.142-1.226-.685-.087-1.265.228-1.352.912-.088.684.423 1.2 1.108 1.288.015.004.976.132 2.345.387l-2.091 7.77c-.182.68.168 1.315.844 1.513.687.184 1.322-.179 1.51-.865l.518-1.902c1.802 3.064 3.309 5.97 3.321 6.003a1.244 1.244 0 0 0 1.625.681c.636-.263.943-.988.68-1.625zm-2.94-10.8c2.874.761 2.711 1.896 2.588 2.354-.46 1.717-3.016 1.84-4.756 1.466l1.11-4.083c.35.081.704.172 1.059.263zM80.246 150.742c.538-2.179-.792-3.851-3.075-4.762-1.016-.406-1.91-.599-2.403-.732.596-2.192.98-3.543.989-3.578a1.248 1.248 0 0 0-2.4-.676c-.013.047-.99 3.503-2.116 7.785l-1.368 5.104c-.122.425-.024.835.23 1.132.014.024.247.241.428.314.056.023.116.048.18.069l.044.012c.99.294 2.912.351 4.383-.058 3.82-1.063 4.758-3.18 5.11-4.601zm-7.525 2.289c.492-1.946 1.482-5.611 1.482-5.611s.807.083 2.144.641c1.348.561 1.653 1.442 1.437 2.25-.565 2.109-2.874 3.094-5.06 2.721z" />
				<path
					d="M49.14 152.616c-1.416-.42-2.98-1.202-4.15-2.648-2.513-3.1-2.39-7.426.319-11.288 1.273-1.816 3.255-3.183 5.733-3.947a14.792 14.792 0 0 1 7.296-.331 1.224 1.224 0 1 1-.504 2.396c-4.151-.871-8.577.508-10.525 3.288-2.088 2.975-2.245 6.093-.421 8.347 1.936 2.392 5.667 2.222 5.704 2.223a1.225 1.225 0 0 1 .131 2.446c-.114.007-1.724.079-3.586-.478z"
					style={{
						display: 'inline',
					}}
				/>
			</g>
			<g
				style={{
					display: 'inline',
				}}
			>
				<g
					clipPath="url(#b)"
					style={{
						display: 'inline',
					}}
				>
					<rect
						width={22.248}
						height={22.246}
						fill="#fff"
						rx={4}
						style={{
							display: 'inline',
						}}
						transform="rotate(14.998 -651.664 269.453) skewX(-.004)"
					/>
				</g>
				<path
					fill="#1a2c48"
					fillRule="evenodd"
					d="m49.246 180.955 6.118 1.64-1.634 6.098-6.118-1.64zm11.157 19.384 1.554.416-.412 1.537-1.554-.417zm-2.997-.803 1.561.418-.39 1.456-3.121-.836.8-2.988 1.504.403.407-1.517 1.537.412.81-3.025 1.567.42-.398 1.485 1.484.398-.411 1.536-1.485-.397-.411 1.536-3.049-.816-.405 1.512zm-3.806-4.314 1.51.405.412-1.537-1.455-.39.412-1.536 1.455.39.412-1.537-1.487-.398-.411 1.536-1.562-.418.412-1.537 1.535.412 1.223-4.564 1.559.418-1.222 4.561 1.51.405-.411 1.536 1.486.398.412-1.536 1.56.418-.413 1.536-1.484-.397-.411 1.536-1.56-.418-.81 3.025-1.511-.405-.818 3.052-1.56-.418zm8.838-2.575 1.56.417-.412 1.537-1.56-.418zm-12.183-3.265 1.56.418-.413 1.537-1.559-.418zm-3.049-.816 1.56.418-.412 1.536-1.56-.418zm9.67-5.567 1.558.418-.411 1.537-1.56-.418zm-10.524 8.658 6.116 1.638-1.634 6.098-6.116-1.638zm1.089 1.884 3.152.844-.84 3.134-3.152-.844zm12.482-9.722 6.113 1.637-1.633 6.096-6.116-1.639 1.634-6.098zm1.09 1.879 3.152.844-.84 3.134-3.152-.844.84-3.137zm-10.67-2.859 3.152.845-.84 3.133-3.153-.844.84-3.137z"
					clipRule="evenodd"
					style={{
						display: 'inline',
					}}
				/>
			</g>
		</g>
	</svg>
);
